import { render } from "./Indexes.vue?vue&type=template&id=1f8cbde4"
import script from "./Indexes.vue?vue&type=script&lang=js"
export * from "./Indexes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__